import CreatableAutocomplete from 'components/CreatableAutocomplete/CreatableAutocomplete'

export default CreatableAutocomplete
